import { trackEventV2 } from 'tracking/tracking';

export const trackPageReloadIfApplicable = (): void => {
  if (
    typeof performance?.getEntriesByType !== 'function' ||
    typeof PerformanceNavigationTiming === 'undefined'
  ) {
    return;
  }

  const navEntry = performance.getEntriesByType('navigation')[0];
  if (
    navEntry &&
    navEntry instanceof PerformanceNavigationTiming &&
    navEntry.type === 'reload'
  ) {
    trackEventV2({
      event: 'Browser history0 Reloaded the page',
    });
  }
};

export const trackBrowserHistoryNavigation = (): void => {
  trackEventV2({
    event: 'Browser history0 Navigated using browser history button',
  });
};
